import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { DeviceDetectionService } from '@shared/providers/device-detection.service';

@Injectable({
  providedIn: 'root'
})
export class DeviceRedirectGuard  {

  constructor(
    private deviceService: DeviceDetectionService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // Si es desktop, redirigir a la versión desktop
    if (this.deviceService.isDesktop) {
      return this.router.createUrlTree(['/desktop']);
    }
    
    // Si es móvil, permitir acceso a tabs
    return true;
  }
}
